import React from 'react'
import { Widget } from 'features/types'
import {
  TopicNotSelectedGuard,
  WidgetLoadingGuard,
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  UnexpectedServiceErrorGuard
} from 'components/widget/share/guards'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import MediaModal from 'components/visualization/MediaModal'

import { useMediaModalInfo } from '../hooks'
import PopularMediaWidget from '../share/PopularMedia'
import PopularMediaEmptyResultGuard from '../share/guards/PopularMediaEmptyResultGuard'
import RunSearchEffect from '../share/RunSearchEffect'
import PopularMediaNoDataGuard from '../share/guards/PopularMediaNoDataGuard'

const SocialWebPopularMediaWidget: Widget = ({ widgetId }) => {
  const { isModalOpen, setIsModalOpen, selectedMedia, handleMediaClick, title } = useMediaModalInfo(
    widgetId
  )
  return (
    <UnexpectedErrorBoundary>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <PopularMediaEmptyResultGuard widgetId={widgetId}>
          <RunSearchEffect widgetId={widgetId}>
            <WidgetLoadingGuard widgetId={widgetId}>
              <TopicInaccessibleGuard widgetId={widgetId}>
                <UnexpectedServiceErrorGuard widgetId={widgetId}>
                  <TopicIndexNotReadyGuard widgetId={widgetId}>
                    <PopularMediaNoDataGuard widgetId={widgetId}>
                      <PopularMediaWidget widgetId={widgetId} onMediaClick={handleMediaClick} />
                    </PopularMediaNoDataGuard>
                  </TopicIndexNotReadyGuard>
                </UnexpectedServiceErrorGuard>
              </TopicInaccessibleGuard>
            </WidgetLoadingGuard>
          </RunSearchEffect>
        </PopularMediaEmptyResultGuard>
      </TopicNotSelectedGuard>
      <MediaModal
        title={title}
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
        }}
        detail={selectedMedia.mediaModalDetail}
        medias={selectedMedia.mediaModalMedias}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebPopularMediaWidget
